import { createContext } from 'react';
export const PopoverContext = createContext(null);
//# sourceMappingURL=PopoverContext.js.map